import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { StiiizyAddressCardStackContentViewModel } from './stiiizy-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { StiiizyCardData } from '../../../../../../../models/print-cards/stiiizy-card-data';

@Component({
  selector: 'app-stiiizy-address-card-stack-content',
  templateUrl: './stiiizy-address-card-stack-content.component.html',
  styleUrls: ['./stiiizy-address-card-stack-content.component.scss'],
  providers: [StiiizyAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: StiiizyAddressCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override data: StiiizyCardData;
}
